import React from 'react'
import useAOS from './useAos'
import SplitText from '../shared/SplitText'

export default function TittleBanner({tiitle, img}) {
    useAOS()
  return (
    <section
        className={`
            overflow-hidden 
             ${img}
             bg-black bg-opacity-100
             bg-blend-soft-light 
             bg-cover bg-center 
             bg-no-repeat
             bg-buttonHover 
             opacity-90`}
             data-aos="fade-left"
             data-aos-delay="300"
             data-aos-duration="600"
        >
        <div className="bg-black/50 p-8 md:p-12 lg:px-16 lg:py-24">
            <div className="text-center ltr:sm:text-left rtl:sm:text-right">
             <SplitText
                text = {tiitle}
                className="text-xl font-bold text-white sm:text-2xl md:text-5xl font-orbitron uppercase"
                delay={300}
                duration={0.6}
                ease="power3.out"
                splitType="chars"
                from={{ opacity: 0, y: 40 }}
                to={{ opacity: 1, y: 0 }}
                threshold={0.1}
                rootMargin="-100px"
                textAlign="center"
              /> 
            </div>
        </div>
        <div className="flex ">
        </div>
        </section>
  )
}
